module.exports = __webpack_public_path__ + "img/EXV_Weinflaschen_Icons_Spirituosen.71fa42a9.svg";